import LogInPage from "../pages/LogIn/LogIn";
import { RoutePaths } from "./RoutePaths";
import HomePage from "../pages/Home/Home";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import AccountPage from "../pages/Account/Account";
import DevicesPage from "../pages/Devices/Devices";
import InvoicesPage from "../pages/Invoices/Invoices";
import CreateNewPasswordPage from "../pages/CreateNewPassword/CreateNewPassword";

export interface RouteItem {
  path: string;
  element: React.ComponentType;
}
export const publicRoutes: RouteItem[] = [
  { path: RoutePaths.LOGIN, element: LogInPage },
  { path: RoutePaths.FORGOT_PASSWORD, element: ResetPassword },
];

export const userRoutes: RouteItem[] = [
  { path: RoutePaths.HOME, element: HomePage },
  { path: RoutePaths.ACCOUNT, element: AccountPage },
  { path: RoutePaths.DEVICES, element: DevicesPage },
  { path: RoutePaths.INVOICES, element: InvoicesPage },
];

export const sharedRoutes: RouteItem[] = [
  { path: RoutePaths.CREATE_NEW_PASSWORD, element: CreateNewPasswordPage },
];
